function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext, useReducer, useMemo } from 'react';
import PropTypes from 'prop-types';

/* -------------------------
 * Reducer
 ------------------------- */

var initialState = {
  hasMain: false,
  hasSidebar: false,
  intros: []
};
export var LayoutReducer = function LayoutReducer(state, action) {
  switch (action.type) {
    case 'ADD_LAYOUT_INTRO':
      {
        var _nextState$intros$;
        var id = action.id,
          children = action.children,
          isFirstRender = action.isFirstRender,
          isAppended = action.isAppended;
        var nextState = _objectSpread({}, state);

        /** intro from LayoutMain should always be first */
        if (id === 'main' && ((_nextState$intros$ = nextState.intros[0]) === null || _nextState$intros$ === void 0 ? void 0 : _nextState$intros$.id) !== 'main') {
          return _objectSpread(_objectSpread({}, nextState), {}, {
            intros: [{
              id: id,
              children: children
            }]
          });
        }
        /** Get the index of the intro */
        var index = nextState.intros.findIndex(function (i) {
          return i.id == id;
        });
        /** Intro already exists - update only */
        if (!isFirstRender && index > -1) {
          return _objectSpread(_objectSpread({}, nextState), {}, {
            intros: nextState.intros.map(function (i) {
              return i.id === id ? _objectSpread(_objectSpread({}, i), {}, {
                children: children,
                isAppended: isAppended
              }) : i;
            })
          });
        }
        /** If a new LayoutIntro is being added, reset the `intros` array */
        if (nextState.intros.filter(function (i) {
          return i.id !== 'main';
        }).length > 0 && isFirstRender) {
          return _objectSpread(_objectSpread({}, nextState), {}, {
            intros: nextState.intros.filter(function (i) {
              return i.id === 'main';
            })
          });
        }
        /** Add new intro to array */
        return _objectSpread(_objectSpread({}, nextState), {}, {
          intros: [].concat(_toConsumableArray(nextState.intros), [{
            id: id,
            children: children,
            isAppended: isAppended
          }])
        });
      }
    case 'REMOVE_LAYOUT_INTRO':
      {
        /** */
        return _objectSpread(_objectSpread({}, state), {}, {
          intros: state.intros.filter(function (_ref) {
            var id = _ref.id;
            return id !== action.id;
          })
        });
      }
    case 'SET_LAYOUT_STATE':
      return _objectSpread(_objectSpread({}, state), action.props);
  }
};

/* -------------------------
 * Layout Context
 ------------------------- */
var LayoutContext = /*#__PURE__*/React.createContext({});
export var LayoutProvider = function LayoutProvider(_ref2) {
  var children = _ref2.children;
  var _useReducer = useReducer(LayoutReducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var contextValue = useMemo(function () {
    return {
      state: state,
      dispatch: dispatch
    };
  }, [state, dispatch]);
  return /*#__PURE__*/React.createElement(LayoutContext.Provider, {
    value: contextValue
  }, children);
};
LayoutProvider.propTypes = {
  children: PropTypes.node
};
LayoutProvider.defaultProps = {
  children: /*#__PURE__*/React.createElement(React.Fragment, null)
};

/* -------------------------
 * Custom Layout Hook
 ------------------------- */
var useLayout = function useLayout() {
  var _useContext = useContext(LayoutContext),
    state = _useContext.state,
    dispatch = _useContext.dispatch;
  var addLayoutIntro = function addLayoutIntro(id, children) {
    var isFirstRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isAppended = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    dispatch({
      id: id,
      children: children,
      isFirstRender: isFirstRender,
      isAppended: isAppended,
      type: 'ADD_LAYOUT_INTRO'
    });
  };
  var removeLayoutIntro = function removeLayoutIntro(id) {
    dispatch({
      id: id,
      type: 'REMOVE_LAYOUT_INTRO'
    });
  };
  var setLayoutState = function setLayoutState(props) {
    dispatch({
      props: props,
      type: 'SET_LAYOUT_STATE'
    });
  };
  return {
    addLayoutIntro: addLayoutIntro,
    dispatch: dispatch,
    layoutState: state,
    removeLayoutIntro: removeLayoutIntro,
    setLayoutState: setLayoutState
  };
};
export default useLayout;